var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2529 0.858398L21.1389 24.4387L11.6362 27.0617L2.15969 24.4423L0.0478516 0.858398H23.2529ZM7.80621 11.5336L7.5407 8.57168L18.6572 8.57167L18.9173 5.6792L4.36589 5.67921L5.14943 14.4261L15.2175 14.4261L14.8802 18.1774L11.6402 19.0481L11.6376 19.049L8.40228 18.1792L8.19544 15.8724H5.27923L5.68619 20.414L11.6369 22.0587L11.6503 22.0551L17.5956 20.414L18.322 12.3103L18.3929 11.5336L7.80621 11.5336Z",
    className: "icon-primary-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml);
export default __webpack_public_path__ + "static/media/icon-html.229349ffa8f92595f9352413196bc850.svg";
export { ForwardRef as ReactComponent };